import * as axios from '~/utilities/axios'

export const shouldBeBlocked = (sessionToken, userEmail) => {
  return axios
    .secure(sessionToken)
    .post(`/api/v1/blocked/user/shouldBeBlocked`,{userEmail})
    .then(res => res.data)
    .catch(axios.parseError)
}
